<template lang="pug">
  v-card
    v-toolbar(:color="theme.colors.primary" dark)
      v-btn(icon :to="{ name: 'institutions.edit', params: { id: id } }" title="Inapoi")
        v-icon arrow_back
      v-toolbar-title Fisiere
      div(class="flex-grow-1")
    v-card-text
      v-text-field(
        v-model="search"
        append-icon="search"
        label="Cauta dupa nume..."
        single-line
        hide-details
        clearable
      )
    v-data-table(
      :headers="headers"
      :items="files"
      :loading="loading"
      :options.sync="options"
      :server-items-length="total"
      :footer-props="{ 'items-per-page-options': [5, 20, 25, 50, 100] }"
      class="elevation-1"
    )
      template(#item="{ item }")
        tr
          td {{ item.name }}
          td(class="text-no-wrap") {{ item.size }}
          td(class="text-no-wrap") {{ item.addedDate }}
          td(class="text-no-wrap text-right")
            v-btn(
              small
              icon
              title="Sterge"
              @click="confirmDelete(item)"
            )
              v-icon(small color="red") delete
    v-dialog(v-model="deleteDialog" max-width="400")
      v-card
        v-card-title Confirmare stergere
        v-card-text Esti sigur ca vrei sa stergi fisierul {{ deleteTarget ? deleteTarget.name : '' }}?
        v-card-actions
          div(class="flex-grow-1")
          v-btn(text @click="deleteDialog = false") Anuleaza
          v-btn(color="red" text @click="deleteFile") Sterge
</template>
<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import _ from 'lodash';

export default {
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      loadFilesDebouncer: null,
      loading: false,
      headers: [
        { text: 'Nume', value: 'name', sortable: false },
        { text: 'Marime', value: 'size', sortable: false },
        { text: 'Data', value: 'created_at', sortable: false },
        { text: '', sortable: false }
      ],
      options: {
        page: 1,
        perPage: 20
      },
      search: '',
      total: 0,
      files: [],
      deleteDialog: false,
      deleteTarget: null
    };
  },
  computed: {
    ...mapState({
      theme: s => s.config.theme
    })
  },
  watch: {
    search: function () {
      this.loadFilesDebouncer();
    },
    options: {
      handler () {
        this.loadFiles();
      },
      deep: true
    }
  },
  created () {
    this.loadFilesDebouncer = _.debounce(this.loadFiles, 500);
  },
  methods: {
    loadFiles () {
      this.loading = true;

      const params = {
        page: this.options.page,
        perPage: this.options.itemsPerPage,
        search: this.search,
        searchBy: 'name'
      };

      return Vue.axios
        .get(`/institutions/${this.id}/files`, { params })
        .then(res => {
          this.files = res.data.data;
          this.total = res.data.meta.pagination.total;
        })
        .catch(e => {
          this.$error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    confirmDelete (item) {
      this.deleteTarget = item;
      this.deleteDialog = true;
    },
    deleteFile () {
      Vue.axios
        .delete(`/institutions/${this.id}/files/${this.deleteTarget.id}`)
        .then(() => {
          this.deleteDialog = false;
          this.deleteTarget = null;
          this.$success('Fisierul a fost sters.');
          this.loadFiles();
        })
        .catch(e => {
          this.$error(e);
        });
    }
  }
};
</script>
